<template>
  <div>
    <div
      class="AboutPageBackground"
      :style="{ backgroundImage: 'url(' + textupdate.photo + ')' }"
    >
      <sidebar></sidebar>

      <div class="text-center">
        <v-dialog v-model="ErrorDialog" width="550">
          <v-card>
            <v-card-title
              class="
                white--text
                text-h5
                font-weight-black
                text-center
                red
                lighten-2
              "
            >
              修 改 上 傳 失 敗
            </v-card-title>

            <v-card-text class="font-weight-black">
              <p class="text-center mt-5">
                <v-icon size="60"> mdi-alert-circle-outline </v-icon>
              </p>
              <p class="font-weight-black text-h6 mt-2">
                在更改作業時即使圖片無須更改也要重新選取一次，
                <br />
                確保資料有正確上傳，且輸入欄不得為空。
              </p>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" text @click="ErrorDialog = false"> OK </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

      <v-container class="text-block">
        <div class="title-Block" @dblclick="ButtonEvent">
          <h2
            v-show="!DisplaySwitch"
            class="HomeTitle text-lg-h2 text-xl-h2 text-center"
          >
            {{ textupdate.title }}
          </h2>
        </div>

        <div class="desc-Block" @dblclick="ButtonEvent">
          <p
            v-show="!DisplaySwitch"
            style="white-space: pre-wrap"
            class="text-left text-lg-h6 text-xl-h5 text-sm-body-5"
          >
            {{ textupdate.desc }}
          </p>
        </div>
      </v-container>
    </div>

    <footer>
      <FooterNav></FooterNav>
    </footer>
  </div>
</template>

<script>
import sidebar from "@/components/The_Sidebar.vue";
import FooterNav from "@/components/footer.vue";
export default {
  components: {
    sidebar,
    FooterNav,
  },

  data: () => ({
    showMenu: false,
    hidden: true,
    ChangeButtonOpen: false,
    dialog: false,
    ErrorDialog: false,
    isTransform: true,

    image: "",

    // 雙擊SHOW input hide文字欄位
    DisplaySwitch: false,

    //About POST Parameter
    textupdate: {
      title: "",
      desc: "",
      photo: "",
    },

    lineshow: false,

    //<!-- Tool bar -->
    direction: "top",
    fab: false,
    fling: false,
    hover: true,
    tabs: null,
    top: false,
    right: false,
    bottom: true,
    left: true,
    transition: "scale-transition",
  }),

  //網頁一渲染先把/show 資料callback回來渲染在畫面上
  created() {
    let vm = this;
    let str = localStorage.getItem("LoginStatus");
    let token = localStorage.getItem("Token");

    if (str == 201) {
      vm.ChangeButtonOpen = true;
    } else if (str == "") {
      vm.ChangeButtonOpen = false;
    }

    let axios = require("axios");
    let config = {
      method: "post",
      url: "https://think-x-tech.synology.me/hotel_system/public/api/about/show",
      headers: {
        Authorization: "Bearer 267|2cEoJMpGw63gFpsaK8crj6sy6kxPPmdQCCgtWKFF",
      },
    };
    axios(config)
      .then(function (response) {
        vm.textupdate.title = response.data.title;
        vm.textupdate.desc = response.data.desc;
        vm.textupdate.photo =
          "https://think-x-tech.synology.me/hotel_system/" + response.data.path;
        console.log(vm.textupdate.photo);
        console.log(response.data);
      })
      .catch(function (error) {
        console.log(error);
        alert("系統錯誤，請聯繫IT人員協助處裡! ! ! !");
      });
  },

  methods: {
    ButtonEvent() {
      let str = localStorage.getItem("LoginStatus");
      // 登入狀態時雙擊效果才會出來
      if (str) {
        this.DisplaySwitch = true;
      } else {
        this.DisplaySwitch = false;
      }
    },

    //登出時將 status 刪除
    Logout() {
      let vm = this;
      localStorage.removeItem("LoginStatus");
      localStorage.removeItem("Token");
      vm.$router.push({
        path: "/login",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$main_color: #ffffff;

.AboutPageBackground {
  background-color: rgb(0 0 0 / 32%);
  background-blend-mode: multiply;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100vw;
  height: 100vh;
  v-container {
    width: 68vw;
  }
  .title-Block {
    margin-bottom: 6%;
  }
  .desc-Block {
    padding: 0 10%;
  }
  .HomeTitle {
    font-weight: 400;
  }
  h2,
  p {
    color: $main_color;
    line-height: 50px;
  }
}
.title-Block {
  margin-top: 10%;
}

.ChangeButton {
  position: fixed;
  bottom: 5%;
  left: 3%;
  display: flex;
  flex-direction: column;
}
.level-line {
  position: relative;
  top: 47%;
  left: 20%;
  width: 60%;
  background-color: #9e9e9e57;
}
.straight-line {
  position: relative;
  top: 7%;
  left: 50%;
  height: 60%;
  background-color: #80808066;
}

//更改image圖片位置的input
.portrait.v-card {
  position: absolute;
  right: 10%;
  bottom: 40%;
  max-width: 600px;
  width: 100%;
}
.file-input {
  height: 100vh;
  width: 100vw;
}
//更改image圖片位置的input

#create .v-speed-dial {
  position: fixed;
}

#create .v-btn--floating {
  position: relative;
}

@media screen and (min-width: 960px) and (max-width: 1264px) {
  .AboutPageBackground {
    .title-Block {
      margin-bottom: 0%;
      margin-top: 20%;
    }
    .desc-Block {
      padding: 5% 0%;
    }
    h2 {
      font-size: 40px;
      margin-bottom: 9%;
    }
    p {
      color: $main_color;
      line-height: 2;
      font-size: 25px;
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 960px) {
  .AboutPageBackground {
    .title-Block {
      margin-bottom: 0%;
      margin-top: 30%;
    }
    .desc-Block {
      padding: 5% 5%;
    }
    h2 {
      font-size: 40px;
      margin-bottom: 10%;
    }
    p {
      color: $main_color;
      line-height: 50px;
      font-size: 20px;
    }
  }
}

@media screen and (max-width: 600px) {
  .AboutPageBackground {
    .title-Block {
      margin-bottom: 0%;
      margin-top: 30%;
    }
    .desc-Block {
      padding: 0 0%;
    }
    h2 {
      font-size: 25px;
      margin-bottom: 0%;
    }
    p {
      color: $main_color;
      line-height: 2;
    }
  }
}

@media screen and (max-width: 320px) {
  .AboutPageBackground {
    background: url(~@/assets/image/ABOUT.jpg);
    background-color: rgb(0 0 0 / 32%);
    background-blend-mode: multiply;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 100vw;
    height: 140vh;
    v-container {
      width: 68vw;
    }
    .title-Block {
      margin-bottom: 0%;
      margin-top: 30%;
    }
    .desc-Block {
      padding: 0 0%;
    }
    h2,
    p {
      color: $main_color;
      margin-bottom: 0%;
    }
  }
}
</style>
